import { BrowserRouter, Route, Routes } from "react-router-dom";
import CompanyContextProvider from "./Contexts/CompanyContext";
import ConfigurationLayout from "./Layouts/ConfigurationLayout";
import MainLayout from "./antd/layouts/MainLayout";
import Home from "./antd/pages/home";
import FinancialAnalysis from "./Pages/FinancialAnalysis";
import ProjectInformations from "./Pages/ProjectInformations";
import Recommendation from "./antd/pages/Recommendation";
import ManagementMenu from "./Pages/ManagementMenu";
import CreateProject from "./Pages/ProjectInformations/CreateProject";
import EditProject from "./Pages/ProjectInformations/EditProject";
import CreateProjectHistory from "./Pages/ProjectInformations/CreateProjectHistory";
import EditProjectHistory from "./Pages/ProjectInformations/EditProjectHistory";
import ProjectLines from "./antd/pages/Recommendation/ProjectLines";
import ProjectsAssigned from "./antd/pages/Recommendation/ProjectsAssigned";
import News from "./Pages/ManagementMenu/News";
import CreateNews from "./Pages/ManagementMenu/News/CreateNews";
import EditNews from "./Pages/ManagementMenu/News/EditNews";
import FileManager from "./Pages/FileManager";
import PathManager from "./Pages/FileManager/PathManager";
import AuthContextProvider from "./Contexts/AuthContext";
import NotFound from "./antd/pages/400";
import InternalServerError from "./antd/pages/500";
import LoggedOutPage from "./antd/pages/LoggedOutPage";
import TimeoutContextProvider from "./Contexts/TimeoutContext";
import Logs from "./Pages/ManagementMenu/Logs";
import LogsAction from "./Pages/LogsAction";
import CheckUser from "./Pages/CheckUser";
import OpportunitiesPanels from "./antd/pages/oportunitiesPanels/index";
// import LinesPresentation from "./Pages/OpportunitiesPanels/LinesPresentation"; // antigo
import LinesPresentation from "./antd/pages/oportunitiesPanels/linesPresentation"
import UserContextProvider from "./Contexts/UserDbContext";
import PersonaAndCompanyFinep from "./Pages/PersonaCompanyFinep";
import RegisterList from "./Pages/Register/RegisterList";
import HiringList from "./Pages/Hiring/HiringList";
import ProjectWithGrouping from "./antd/pages/projectsGrouping/ProjectWithGrouping";
import ProjectGroupingLines from "./antd/pages/Recommendation/ProjectGroupingLines";
import FinancialLines from "./antd/pages/FinancialLines";
import ThemeContext from "./Contexts/theme.context";
import ControlPanelPage from "./antd/pages/controlPanel";
import AddRubricaPlea from "./Pages/Plea/add/rubrica";
import AddEmployeePlea from "./Pages/Plea/add/employee";
import AddThirdPartyPlea from "./Pages/Plea/add/thirdParty";
import SocioEnvironmentalPlea from "./Pages/Plea/socioEnvironmental";
import ContractPage from "./Pages/Contract";
import CardsList from "./Pages/Plea/list";
import RegisterSubvention from "./antd/pages/register/subvention";
import RegisterRefundable from "./antd/pages/register/refundable";
import NotAuthorized from "./antd/pages/403";
import TechnicalPlea from "./Pages/Plea/technicalPlea";
import CardsOptions from "./Pages/Plea/cardsOptions";
import GrantsSearcher from "./Pages/GrantsSearcher";
import GrantsLines from "./antd/pages/grants/list";
import GrantsLineInfo from "./Pages/GrantsSearcher/GrantsLineInfo";
import { CompanyContextFinepProvider } from "./Contexts/CompanyFinepContext";

import TabRegisterFinepContextChildren from "./Pages/Finep/RegisterFinep/TabContextChildren";
import TabCompanyFinepContextChildren from "./Pages/Finep/CompanyFinepTabList/TabContextChildren";
import TabRegistrationDocumentsFinepContextChildren from "./Pages/Finep/RegistrationDocumentsFinep/TabContextChildren";
import TabTechnologicalFeaturesFinepContextChildren from "./Pages/Finep/TechnologicalFeaturesFinep/TabContextChildren";
import ProjectsGrouping from "./antd/pages/projectsGrouping";
import LoaderContextProvider from "./antd/contexts/LoaderContext";
import PleaSchedule from "./Pages/Plea/schedule";
import BudgetPlea from "./Pages/Plea/budget";

export default function Routers() {

    return (
        <TimeoutContextProvider>
            <LoaderContextProvider>
                <CompanyContextProvider>
                    <AuthContextProvider>
                        <UserContextProvider>
                            <CompanyContextFinepProvider>
                                <ThemeContext>
                                    <BrowserRouter>
                                        <Routes>

                                            {/* LAYOUT SEM NAVEGAÇÃO */}
                                            <Route path="/" element={<MainLayout hideNavigation hideHeader />}>
                                                <Route path="/" element={<CheckUser />} />
                                                <Route path="/control/:id" element={<ControlPanelPage />} />
                                                <Route path="/finance/financialLines" element={<FinancialLines />} />
                                                <Route path="/finance/financialLines/subvention" element={<RegisterSubvention />} />
                                                <Route path="/finance/financialLines/refundable" element={<RegisterRefundable />} />
                                            </Route>

                                            {/* LAYOUT DE CONFIGURAÇÃO */}
                                            <Route path="/" element={<ConfigurationLayout />}>
                                                <Route path="/managementMenu" element={<ManagementMenu />} />
                                                <Route path="/managementMenu/news" element={<News />} />
                                                <Route path="/managementMenu/news/create" element={<CreateNews />} />
                                                <Route path="/managementMenu/news/edit/:id" element={<EditNews />} />
                                                <Route path="/managementMenu/logs" element={<Logs />} />
                                            </Route>

                                            {/* LAYOUT DE USUÁRIO COMUM */}
                                            <Route path="/" element={<MainLayout />}>
                                                <Route path="home/:id" element={<Home />} />
                                                <Route path="/financialAnalysis/:id" element={<FinancialAnalysis />} />
                                                <Route path="/projectGrouping/:id" element={<ProjectsGrouping />} />
                                                <Route path="/projectGrouping/:id/:groupingId" element={<ProjectWithGrouping />} />
                                                <Route path="/opportunitiesPanels/:id" element={<OpportunitiesPanels />} />
                                                {/* <Route path="/opportunitiesPanels/LinesPresentation/:opportunitiesPanelsId" element={<LinesPresentation />} /> */}
                                                <Route path="/opportunitiesPanels/linesPresentation/:opportunitiesPanelsId" element={<LinesPresentation />} />
                                                <Route path="/recommendations/:id" element={<Recommendation />} />
                                                <Route path="/recommendations/ProjectGroupingLines/:id/:projectGroupingId" element={<ProjectGroupingLines />} />
                                                <Route path="/recommendations/ProjectLines/:id/:projectId" element={<ProjectLines />} />
                                                <Route path="/recommendations/ProjectsAssigned/:id/:lineId" element={<ProjectsAssigned />} />
                                                <Route path="/grantsSearcher/:id" element={<GrantsSearcher />} />
                                                <Route path="/grantsSearcher/grants" element={<GrantsLines />} />
                                                <Route path="/grantsSearcher/grants/:id" element={<GrantsLineInfo />} />
                                                <Route path="/fileManager/:id" element={<FileManager />} />
                                                <Route path="/fileManager/pathManager/:id/:pathMain" element={<PathManager />} />
                                                <Route path="/fileManager/pathManager/:id/:pathMain/:pathId" element={<PathManager />} />
                                                <Route path="/Logs/:id" element={<LogsAction />} />
                                                <Route path="/projectInformation/:id" element={<ProjectInformations />} />
                                                <Route path="/projectInformation/createProject/:id/:type/:opportunityId" element={<CreateProject />} />
                                                <Route path="/projectInformation/createProjectHistory/:id" element={<CreateProjectHistory />} />
                                                <Route path="/projectInformation/editProject/:projectId" element={<EditProject />} />
                                                <Route path="/projectInformation/editProjectHistory/:projectId" element={<EditProjectHistory />} />
                                                <Route path="/register/:id" element={<RegisterList />} />

                                                {/* EM TESTE ABAIXO */}
                                                <Route path="/plea/financial/finep/:pleaId/:id" element={<CardsOptions />} />
                                                <Route path="/plea/schedule/:id/:pleaId" element={<PleaSchedule />} />
                                                <Route path="/plea/financial/list/:id" element={<CardsList />} />
                                                <Route path="/plea/financial/new/rubrica/:id" element={<AddRubricaPlea />} />
                                                <Route path="/plea/financial/new/employee/:id" element={<AddEmployeePlea />} />
                                                <Route path="/plea/financial/new/third/:id" element={<AddThirdPartyPlea />} />
                                                <Route path="/plea/biological/:pleaId/:id" element={<SocioEnvironmentalPlea />} />
                                                <Route path="/plea/technical/:pleaId/:id" element={<TechnicalPlea />} />
                                                <Route path="/plea/budget/:id/:pleaId" element={<BudgetPlea />} />

                                                <Route path="/hiring/:id" element={<HiringList />} />
                                                <Route path="/hiring/:id/contract" element={<ContractPage />} />

                                                {/* FINEP */}
                                                <Route path="/registrationFinep/:registerId/:id" element={<TabRegisterFinepContextChildren />} />

                                                <Route path="/personaCompanyFinep/:registerId/:id" element={<PersonaAndCompanyFinep />} />
                                                <Route path="/companyFinep/:companyId/:registerId/:id" element={<TabCompanyFinepContextChildren />} />
                                                <Route path="/companyFinep/:registerId/:id" element={<TabCompanyFinepContextChildren />} />
                                                <Route path="/technologicalFeaturesFinep/:registerId/:id" element={<TabTechnologicalFeaturesFinepContextChildren />} />
                                                <Route path="/registrationDocumentsFinep/:registerId/:id" element={<TabRegistrationDocumentsFinepContextChildren />} />
                                            </Route>

                                            {/* LAYOUT SEM NAVEGAÇÃO */}
                                            <Route path="/" element={<MainLayout hideNavigation hideHeader />}>
                                                <Route path="/control/:id" element={<ControlPanelPage />} />
                                                <Route path="*" element={<NotFound />} />
                                                <Route path="/500" element={<InternalServerError />} />
                                                <Route path="/403" element={<NotAuthorized />} />
                                                <Route path="/session-expired" element={<LoggedOutPage />} />
                                            </Route>

                                        </Routes>
                                    </BrowserRouter>
                                </ThemeContext>

                            </CompanyContextFinepProvider>
                        </UserContextProvider>
                    </AuthContextProvider>
                </CompanyContextProvider>
            </LoaderContextProvider>
        </TimeoutContextProvider>
    )
}

